import { render } from "./ServiceSlugPage.vue?vue&type=template&id=3803f8cb"
import script from "./ServiceSlugPage.vue?vue&type=script&lang=js"
export * from "./ServiceSlugPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__